import { UPDATE_DEVICE } from 'services/Permissions';
import { RANGE_LABEL_DAY, SENSOR_GRAPH_RANGES } from 'services/charting/constants';
import { ruleFields } from "services/utils";

export const CONNECTIVITY_GRAPH_RANGE_STATE_KEY = 'sensor:connectivityGraphRange';
export const CCON_GRAPH_RANGE_STATE_KEY = 'ccon:cconGraphRange';
/* @ngInject */
export default class ActiveAlertsController {
    
    constructor($scope, AlertsAndRulesService, SensorService, FeatureFlags, UserPreferencesManager, RoleManager, RulesService, StateService) {
        this.$scope = $scope;
        this.AlertsAndRulesService = AlertsAndRulesService;
        this.SensorService = SensorService;
        this.FeatureFlags = FeatureFlags;
        this.UserPreferencesManager = UserPreferencesManager;
        this.RoleManager = RoleManager;
        this.RulesService = RulesService;
        this.StateService = StateService;
    }
    
    $onInit() {
        this.fields = ruleFields;
        this.ranges = SENSOR_GRAPH_RANGES
        this.loadedAlerts = false
        this.loadingMore = false
        this.nextPageToken = null
        this.alerts = [];
        this.rules = [];

        this.StateService.setItem(CONNECTIVITY_GRAPH_RANGE_STATE_KEY, 'Week');
        this.StateService.setItem(CCON_GRAPH_RANGE_STATE_KEY, 'Week');

        const listActiveAlertsPromise = this.AlertsAndRulesService.listActiveAlerts().then(response => {
            this.nextPageToken = response.nextPageToken || null;
            return this.processAndAppendAlerts(response.data);
        });

        const listRulesPromise = this.RulesService.listRules().then(response => {
            this.rules = response.data || [];
        }).catch(() => {
            this.rules = [];
        });

        Promise.all([listActiveAlertsPromise, listRulesPromise]).then(() => {
            this.loadedAlerts = true;
            this.$scope.$applyAsync();
        }).catch(error => {
            console.error('An error occurred:', error); // eslint-disable-line no-console
        });

    }

    processAndAppendAlerts(alerts) {
        alerts.forEach(alert => {
            alert.showRangeDropdown = false;
            alert.currentRange = RANGE_LABEL_DAY;
            alert.zoomedIntoAlert = true;
            alert.events.sort((a, b) => {
                return new Date(b.createTime) - new Date(a.createTime);
            });
        });

        const deviceIds = alerts.map(alert => alert.device.split('/')[3]);

        return this.SensorService.getFromCache(deviceIds).then(devicesResponse => {
            const devices = devicesResponse.devices;
            alerts.forEach(alert => {
                const device = devices.find(d => d.name === alert.device);
                alert.device = device;
            });
            this.alerts.push(...alerts);
            this.alerts.sort((a, b) => {
                return new Date(b.createTime) - new Date(a.createTime);
            });
        });
    }

    loadMore() {
        if (!this.nextPageToken || this.loadingMore) return;
        this.loadingMore = true;
        this.AlertsAndRulesService.listActiveAlerts(this.nextPageToken).then(response => {
            this.nextPageToken = response.nextPageToken || null;
            return this.processAndAppendAlerts(response.data);
        }).then(() => {
            this.loadingMore = false;
            this.$scope.$applyAsync();
        }).catch(error => {
            console.error('Failed to load more alerts:', error); // eslint-disable-line no-console
            this.loadingMore = false;
            this.$scope.$applyAsync();
        });
    }

    get canCreate() {
        return this.RoleManager.can(UPDATE_DEVICE);
    }
 
    $onDestroy() {}

}
